$(document).ready(function() {

	//$('.hero-video').get(0).play();
	const heroVideo = $('.hero-video').get(0);

if (heroVideo && typeof heroVideo.play === 'function') {
  heroVideo.muted = true;   // required for autoplay in most browsers
  heroVideo.play().catch(() => {});
}
	

// BEGIN of script for header submenu
	// $('#header li').hover(function(e){
	// 	$(this).addClass('active');
	// }, function(){
	// 	$(this).removeClass('active');
	// });

	if(window.innerWidth >= 768){
		$('#header li').hover(function(e){
			$(this).addClass('active');
		}, function(){
			$(this).removeClass('active');
		});
	} else {
		$('#header li').click(function(e){
			$(this).toggleClass('active');
		});

		$('.collapsible-on-xs-btn').click(function() {
			if ($(this).parents('.collapsible-on-xs').hasClass('active')) {
				console.log('Has active class');
				$('.collapsible-on-xs').removeClass('active');
			} else {
				console.log('NOOO active class');
				$('.collapsible-on-xs').removeClass('active');
				$(this).parents('.collapsible-on-xs').addClass('active');
			}
			if ($(this).hasClass('disable-link-on-xs')) {
				return false;
			}
		});
	}

	$('.btn-close-nav').click(function() {
		setTimeout(function() {
			$('#header li').removeClass('active');
		}, 300);
	});
// END of script for header submenu



	// $('.collapsible-on-xs-btn').click(function() {
	// 	if ($(this).parents('.collapsible-on-xs').hasClass('active')) {
	// 		console.log('Has active class');
	// 		$('.collapsible-on-xs').removeClass('active');
	// 	} else {
	// 		console.log('NOOO active class');
	// 		$('.collapsible-on-xs').removeClass('active');
	// 		$(this).parents('.collapsible-on-xs').addClass('active');
	// 	}
	// 	if ($(this).hasClass('disable-link-on-xs')) {
	// 		return false;
	// 	}
	// });


// BEGIN of script for .slider-home-hero
	$('.slider-home-hero').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: true,
		adaptiveHeight: false,
		autoplay: true,
		autoplaySpeed: 16000,
		fade: true,
		pauseOnHover: false,
		speed: 1200,
	});
// END of script for .slider-home-hero






















});